<div class="ion-margin ion-padding" #content>
  <div class="wrapper" [style.--size]="size" *ngIf="size">
    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 62 62"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
  </div>
</div>
